import React, { memo } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { faCircleQuestion } from '@fortawesome/pro-duotone-svg-icons'
import FaIcon from '../faIcon/FaIcon'

const PopoverHelpText = ({ label }) => {
  return (
    <Tooltip title={label} arrow placement='top'>
      <IconButton
        sx={{
          ml: 0.5,
          p: 0.375,
          fontSize: 'inherit',
          '&:hover': { backgroundColor: 'transparent' }
        }}
        disableRipple
      >
        <FaIcon icon={faCircleQuestion} />
      </IconButton>
    </Tooltip>
  )
}

export default memo(PopoverHelpText)
